import { withFlowComponent } from '@/HOC/withFlowComponent';
import { AppHeaderContainerMobile } from './AppHeaderContainerMobile';
import { AppHeaderContainerDesktop } from './AppHeaderContainerDesktop';

export const AppHeaderContainer = withFlowComponent(
  AppHeaderContainerMobile,
  AppHeaderContainerDesktop
);
